import {Action, createReducer, on} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {EntityUpdate} from './entity-update.model';
import * as EntityUpdateActions from './entity-update.actions';
import {initial} from '~utils/ngrx-util';

export const entityUpdateFeatureKey = 'entityUpdate';

export interface State extends EntityState<EntityUpdate> {
}

export const adapter: EntityAdapter<EntityUpdate> = createEntityAdapter<EntityUpdate>();

export const initialState: State = adapter.getInitialState(initial);

const entityUpdateReducer = createReducer(
  initialState,
  on(EntityUpdateActions.updatedsIds, (state, {entities}) => ({...adapter.upsertMany(entities, state)})),
  on(EntityUpdateActions.clearUpdatedsIds, state => ({...adapter.removeAll(state)}))
);

export const reducer = (state: State | undefined, action: Action): State => entityUpdateReducer(state, action);

export const {selectIds, selectEntities, selectAll, selectTotal} = adapter.getSelectors();


